import  api  from './api';

const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': false
    }
}

export const getClients = async () => {
    let clients = null;
    try {
        const response = await api.get(`Cliente/listcontroller`, config);
        clients = response.data.data;
    } catch (err) {}
    return clients;
}